export const DMS_CONSTANTS = {
    INVOICED_PASCAL_CASE: "Invoiced",
    CONFIG_DICTIONARY: "ConfigDictionary",
    DAY: "day",
    MANAGE_SECONDARY_ORDER_INVOICE : "manageSecondaryOrderInvoice",
    ALL :"ALL",
    MULTIPLE_FILTERS_LIST_MANAGE_SECONDARY_ORDER_INVOICE: "multipleFiltersListManageSecondaryOrderInvoice",
    STATUS:"status",
    SALE_PASCAL_CASE : "Sale",
    MANAGE_SECONDARY_ORDER_INVOICE_PAGE_ID: "ManageSecondaryOrderInvoice",
    POSITIVE : "positive",
    START: "start",
    END: "end",
    ORDER_CONFIGURATION: "order_configuration",
    DMS_CONFIGURATION: "dms_configuration",
    CLAIMS: "claims"


} as const;